// extracted by mini-css-extract-plugin
module.exports = {"primary":"#f7901e","secondary":"#fdcc10","tertiary":"#3f51b5","quaternary":"#159565","quinary":"#cd6832","accent":"#f7901e","error":"#f7581e"};